import { ClipboardPlus } from "lucide-react";
import { Badge, Button, Card } from "../components/ui";

export function AssistancePage() {
  return (
    <div className="page-stack">
      <Card
        title="Acionamento do benefício"
        description="Módulo mínimo de elegibilidade e autorização funerária."
        action={
          <Button>
            <ClipboardPlus size={16} /> Abrir solicitação
          </Button>
        }
      >
        <div className="empty-state">
          <strong>Nenhuma solicitação aberta no ambiente demo</strong>
          <p>
            O módulo registra pessoa coberta, carência, benefício acionado, autorização, prestador e
            conclusão. Estoque, frota e cerimonial ficam fora desta fase.
          </p>
          <Badge tone="info">PRONTO PARA CONECTAR</Badge>
        </div>
      </Card>
    </div>
  );
}
